import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { Checkbox } from '../Checkbox';
import { SEASONS, SeasonsType } from '../../../../../models/hotel-reviews';
import { getVerbalHotelReviews } from '../../../../../utils/format';
import S from '../../../../../stores';

export interface SeasonsFilterProps {
    reviewsAmount: {
        Summer: number;
        Spring: number;
        Winter: number;
        Fall: number;
    };
}

interface StyledSeasonsFilterProps
    extends JSSClassesProps<ComponentJSSClasses>,
        SeasonsFilterProps {}

export const SeasonsFilter = observer((props: StyledSeasonsFilterProps) => {
    const { classes, reviewsAmount } = props;

    const isChecked = (season: SeasonsType): boolean =>
        S.hotelReviews.seasonsFilter.includes(season);

    const handleChange = (season: SeasonsType) => {
        S.hotelReviews.setSeasonFilter(season);
    };

    const getReviewsAmountCaption = (label: SeasonsType): string =>
        `${reviewsAmount[label]} ${getVerbalHotelReviews(reviewsAmount[label])}`;

    const renderSeasonCheckBox = (season: { label: SeasonsType; inputName: string }) => {
        const { label, inputName } = season;
        return (
            <Checkbox
                inputName={inputName}
                label={label}
                checked={isChecked(label)}
                onChange={() => handleChange(label)}
                caption={getReviewsAmountCaption(label)}
            />
        );
    };

    return (
        <div className={classes.container}>
            {SEASONS.map((season, id) => (
                <React.Fragment key={`${season.label}_${id}`}>
                    {renderSeasonCheckBox(season)}
                </React.Fragment>
            ))}
        </div>
    );
});
